// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-00e6e29a]{color:#0c83d3}.social--media[data-v-00e6e29a]{display:flex;align-items:center;justify-content:center;margin-bottom:4px;margin-right:4px;margin-top:4px}.social--media img[data-v-00e6e29a]{width:24px;height:24px;object-fit:contain;margin-right:4px}", ""]);
// Exports
module.exports = exports;
